import CryptoJS from 'crypto-js';
import md5 from "js-md5";
 
export default {
    //随机生成指定数量的16进制key
    generatekey(token,Timestamp) {
        return md5(token+Timestamp).substring(0,16).toUpperCase();
    },
    
    //加密
    encrypt(word, keyStr) {
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv:key});
        return encrypted.toString();
    },
    //解密
    decrypt(word, keyStr) {
        // word = JSON.stringify(word.replace(/[\n]/g, ''))
        var key = CryptoJS.enc.Utf8.parse(keyStr);
        var decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv:key });
        return CryptoJS.enc.Utf8.stringify(decrypt).toString();
    }
 
}


// WEBPACK FOOTER //
// ./src/lib/encryption.js